var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRemove = function SvgRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.426 23.426"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "remove_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 140",
    fill: "none",
    d: "M0 0h23.426v23.426H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Vector Smart Object",
    opacity: 0.302
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Vector Smart Object"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 399"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 398",
    clipPath: "url(#remove_svg__a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 425",
    d: "M11.713 0a11.713 11.713 0 1 0 11.713 11.713A11.726 11.726 0 0 0 11.713 0m0 21.612a9.9 9.9 0 1 1 9.9-9.9 9.91 9.91 0 0 1-9.9 9.9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 426",
    d: "M16.253 10.725H12.62v-3.63a.907.907 0 0 0-1.815 0v3.629H7.177a.907.907 0 1 0 0 1.815h3.629v3.629a.907.907 0 0 0 1.815 0v-3.629h3.632a.907.907 0 0 0 0-1.815"
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Color Overlay",
    d: "M0 11.714a11.713 11.713 0 1 1 11.714 11.712A11.726 11.726 0 0 1 0 11.714Zm1.814 0a9.9 9.9 0 1 0 9.9-9.9 9.911 9.911 0 0 0-9.9 9.9Zm5.227.995a.974.974 0 0 1 0-1.947h9.245a.974.974 0 0 1 0 1.947Z",
    fill: "#515151"
  }))));
};
export default SvgRemove;